import React from "react";
import { useFormContext } from "react-hook-form";
import DateHelper from "../../../../helpers/date.helper";
import { CalculatorQuestion } from "../../models/CalculatorStep";
import { CalculatorTranslations } from "../../models/CalculatorTranslations";
import { FamilyFormState } from "../../models/FamilyFormState";
import { QuestionInput } from "./QuestionInput";

export type QuestionProps = {
  question: CalculatorQuestion;
  translations: CalculatorTranslations;
};

export function Question({ question, translations }: QuestionProps) {
  const { getValues, watch } = useFormContext<FamilyFormState>();

  watch(question.field);

  let activeMessage: string = "";
  if (question.input === "option") {
    activeMessage =
      question.options.find(
        (option) => option.value === getValues(question.field)
      )?.message || "";
  }

  // date message logic:
  // Compare current date 'age' to the value logic.
  // A value can start with < or >, indicating if we want the current value
  // to be smaller or bigger than the following number.
  // The first matching case's message will be shown.
  if (question.input === "date" && question.options?.length) {
    const currentValue = getValues(question.field);
    if (currentValue) {
      const age = DateHelper.calculateAge(new Date(currentValue));
      if (age !== NaN) {
        const activeOption = question.options.find((option) => {
          const checkValue = parseInt(
            option.value.replace("<", "").replace(">", "")
          );
          if (typeof checkValue === "number" && checkValue !== NaN) {
            if (option.value.startsWith("<")) {
              return age < checkValue;
            }
            if (option.value.startsWith(">")) {
              return age > checkValue;
            }
          }
          return false;
        });

        if (activeOption) {
          activeMessage = activeOption.message || "";
        }
      }
    }
  }

  let blockingMessage = false;
  if (question.blocking) {
    blockingMessage = question.blocking(getValues());
  }

  return (
    <div className="mb-3">
      <QuestionInput question={question} translations={translations} />
      {activeMessage && (
        <p
          className={`last-child-no-margin alert ${
            blockingMessage ? "alert-danger" : "alert-warning"
          }`}
          dangerouslySetInnerHTML={{ __html: activeMessage }}
        />
      )}
      {question.description && (
        <div
          className="text-smaller mb-4 last-child-no-margin"
          dangerouslySetInnerHTML={{ __html: question.description }}
        />
      )}
    </div>
  );
}
